import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "aws-amplify";
import { api, extractAmplifyStandardResponseData, extractStandardResponseData } from "src/api/api";

export const getMostFrequentUsers = createAsyncThunk(
  "analytics/getMostFrequentUsers",
  async () =>
    API.get("api", "analytics/getMostFrequentUsers/", {}).then(extractAmplifyStandardResponseData)
  // await api
  //   .get("analytics/getMostFrequentUsers")
  //   .then(extractStandardResponseData)
);

export const getMostPopularCourses = createAsyncThunk(
  "analytics/getMostPopularCourses",
  async () =>
    API.get("api", "analytics/getMostFrequentCourses/", {}).then(extractAmplifyStandardResponseData)
  // await api
  //   .get("analytics/getMostFrequentCourses")
  //   .then(extractStandardResponseData)
);

export const getAnalytics = createAsyncThunk(
  "analytics/get",
  // async () => await api.get("/admin/count").then((res) => res.data)
  async () => await API.get("api", "admin/count/", {})
);
